// extracted by mini-css-extract-plugin
export var badge = "DevBadge-module--badge--w5sKD";
export var badgeIcon = "DevBadge-module--badgeIcon--Gi4LJ";